import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import * as CryptoJS from 'crypto-js';
@Injectable({
    providedIn: 'root'
})
export default class OAuthService {

    constructor(private http: HttpClient) { }

    login( credential: any): Observable<any> {
       return this.http.post<any>( `${environment.baseUrl}/api/oauth`, credential );
    }

    saveData( data : any ){
      sessionStorage.setItem('data', CryptoJS.AES.encrypt(JSON.stringify(data), environment.keyCrypto).toString());
    }

    getData(){
      let data = sessionStorage.getItem('data');
      if(data){
        return JSON.parse(CryptoJS.AES.decrypt(data, environment.keyCrypto).toString(CryptoJS.enc.Utf8));
      }
      return null;
    }

}
